import React,{ useEffect,useState } from "react";
import { Modal, ModalHeader, ModalBody,ModalFooter, Button, Row, Col, Card, CardBody } from "reactstrap";
import { getPermissionsApi, getDesignationPermissionsApi, getUserOverridesApi,updateUserOverridesApi } from "../../apiServices/permission.services";
import { toast } from "react-toastify";
import AppLoader from "../Common/AppLoader";

const UserPermissionOverrideModal = ({ isOpen, toggle, selectedUser, }) => {
    const [loading,setLoading]=useState(false);
    const [allPermissions,setAllPermissions]=useState([]);
    const [designationPermissions,setDesignationPermissions]=useState([]);
    const [allow,setAllow]=useState([]);
    const [deny,setDeny]=useState([]);
    const [search,setSearch]=useState("");

    const groupedPermissions = allPermissions.reduce((acc,p)=>{
    const moduleName = p.module || "General";
    if(!acc[moduleName]) acc[moduleName]=[];
    acc[moduleName].push(p);
    return acc;
    },{});

    const toggleAllow = permission => {
        setAllow(prev =>
            prev.includes(permission)
            ? prev.filter(p=>p!==permission)
            : [...prev,permission]
        );

        setDeny(prev =>
            prev.filter(p=>p!==permission)
        );
    };

    const toggleDeny = permission => {
        setDeny(prev =>
            prev.includes(permission)
            ? prev.filter(p=>p!==permission)
            : [...prev,permission]
        );

        setAllow(prev =>
            prev.filter(p=>p!==permission)
        );
    };
    const effectivePermissions = [
    ...new Set([
        ...designationPermissions,
        ...allow
    ])
    ].filter(p=>!deny.includes(p));


    const fetchData=async()=>{
    try{
        setLoading(true);
        const [ permissionsRes, designationRes, overrideRes ] = await Promise.all([ getPermissionsApi(), getDesignationPermissionsApi( selectedUser?.designationId?._id ),
        getUserOverridesApi( selectedUser?._id )
        ]);

        setAllPermissions( permissionsRes?.data || [] );

        setDesignationPermissions( designationRes?.data?.permissions || [] );

        setAllow( overrideRes?.data?.allow || [] );

        setDeny( overrideRes?.data?.deny || [] );

    }catch(error){
        console.error(error);
    }finally{
        setLoading(false);
    }
    };

    const handleSave = async() => {
        try {
            setLoading(true);
            const res = await updateUserOverridesApi( selectedUser._id, { allow, deny, } );
            if(res?.success){
                toast.success("Permissions updated successfully");
                toggle();
            }
        } catch(error) {
            toast.error( error?.message || "Failed to update permissions" );
        } finally {
            setLoading(false);
        }
    };

    const handleReset = async() => {
        try {
            setLoading(true);
            const res = await updateUserOverridesApi( selectedUser._id, { allow:[], deny:[] } );
            if(res?.success){
                setAllow([]);
                setDeny([]);
                toast.success( "Overrides removed" );
            }
        } catch(error){
            toast.error( error?.message || "Failed to reset" );
        } finally {
            setLoading(false);
        }
    };

    useEffect(()=>{
    if(!isOpen || !selectedUser?._id) return;

    fetchData();
    },[isOpen,selectedUser]);
  return (
    <Modal isOpen={isOpen} toggle={toggle} size="xl" centered scrollable className="permission-modal" >
      <ModalHeader toggle={toggle}> Manage Permissions </ModalHeader>

        <ModalBody style={{ maxHeight:"75vh", overflowY:"auto", background:"#f8f9fa" }} >
        {
            loading ? (
            <div className="text-center py-5"> <AppLoader /> </div>
            ) : (
            <Row>
                <Col md={4}>
                    <div className="d-md-block" style={{ position:"sticky", top:"20px" }}>
                        <Card className="border-0 shadow-sm ">
                            <CardBody>
                                <div className="text-center">
                                    <div
                                        className="rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center"
                                        style={{ width:"70px", height:"70px", background:"#556ee6", color:"#fff", fontSize:"22px", fontWeight:700 }}
                                    >
                                        {selectedUser?.firstName?.[0]}
                                        {selectedUser?.lastName?.[0]}
                                    </div>

                                    <h5 className="mb-1"> {selectedUser?.firstName} {selectedUser?.lastName} </h5>
                                    <div className="text-muted"> {selectedUser?.designationId?.title} </div>

                                    <div className="small text-muted mt-1"> {selectedUser?.departmentId?.name} </div>
                                </div>
                                <hr />
                                <input
                                    className="form-control"
                                    placeholder="Search Permission..."
                                    value={search}
                                    onChange={e=>setSearch(e.target.value)}
                                />
                            </CardBody>
                        </Card>
                        <Card className="border-0 shadow-sm mt-3 d-none d-md-block">
                            <CardBody>
                                <h6 className="mb-3"> Effective Permissions
                                    <span className="badge bg-primary ms-2"> {effectivePermissions.length} </span>
                                </h6>

                                <div style={{ maxHeight:"250px", overflowY:"auto" }} className="d-flex flex-wrap gap-2" >
                                {effectivePermissions.map(permission=>(
                                    <span key={permission} className="badge bg-success" > {permission} </span>
                                ))}
                                </div>
                            </CardBody>
                        </Card>
                    </div>
                </Col>
                <Col md={8}>
                {
                    Object.entries(groupedPermissions).map(([module,items])=>{
                    const filteredItems = items.filter(p =>
                        (p.label || p.name)
                        .toLowerCase()
                        .includes(search.toLowerCase())
                    );
                    if(!filteredItems.length) return null;
                    return (
                        <Card key={module} className="border-0 shadow-sm mb-4" >
                        <CardBody>
                            <h5 className="mb-4" style={{ color:"#0bb197", borderBottom:"1px solid #eee", paddingBottom:"10px" }} > {module} </h5>
                            {filteredItems.map(permission=>{
                                    const permissionName = permission.name;
                                    const isDesignation = designationPermissions.includes( permissionName );
                                    const isAllowed = allow.includes( permissionName );
                                    const isDenied = deny.includes( permissionName );
                                    return (
                                        <div key={permission._id} className="border rounded-3 p-3 mb-3 bg-white" >
                                            <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">

                                                <div className="d-flex align-items-center gap-3">
                                                    <div className="rounded d-flex align-items-center justify-content-center" style={{ width:"48px", height:"48px", background:"#f3f8ff", fontSize:"22px", color:"#556ee6" }} >
                                                        <i className="mdi mdi-shield-key-outline" />
                                                    </div>
                                                    <div>
                                                        <div className="fw-bold fs-5"> {permission.label || permission.name} </div>
                                                        <small className="text-muted"> Permission Control </small>
                                                    </div>
                                                </div>

                                                <div className="d-flex flex-wrap align-items-center gap-2">
                                                    <button type="button"
                                                        className={`btn btn-sm ${ isDesignation ? "btn-primary" : "btn-light" }`}
                                                        disabled
                                                    >
                                                        Base Permission </button>
                                                    <button
                                                        type="button"
                                                        className={`btn btn-sm ${ isAllowed ? "btn-success" : "btn-outline-success" }`}
                                                        onClick={()=>toggleAllow(permissionName)}
                                                    >
                                                        <i className="mdi mdi-check me-1" /> Allow </button>
                                                    <button
                                                        type="button"
                                                        className={`btn btn-sm ${ isDenied ? "btn-danger" : "btn-outline-danger" }`}
                                                        onClick={()=>toggleDeny(permissionName)}
                                                    >
                                                        <i className="mdi mdi-close me-1" /> Deny </button>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })
                            }
                        </CardBody>
                        </Card>
                    );
                    })
                }

                </Col>
            </Row>
            )
        }
        </ModalBody>
        <ModalFooter>
            <Button color="light" onClick={handleReset} disabled={loading} > Reset Overrides </Button>
            <Button color="primary" onClick={handleSave} disabled={loading} > Save Changes </Button>
        </ModalFooter>
    </Modal>
  );
};

export default UserPermissionOverrideModal;